import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LoaderService } from './loader.service';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
	status$ = this.loaderService.status$;

	constructor(private readonly loaderService: LoaderService) {}
}
